import React, { forwardRef } from "react";

import { concatClassNames } from "../../utils/styles";
import { icons } from "./ButtonPrimary";
import { Clickable } from "./Clickable";
import { ConditionalIcons } from "./ConditionalIcons";
import { ClickableProps } from "./types";

import styles from "./TextLink.module.scss";

export const TextLink = forwardRef<
    HTMLButtonElement | HTMLAnchorElement,
    ClickableProps
>(function TextLink(props, ref) {
    return (
        <Clickable
            {...props}
            ref={ref}
            className={concatClassNames([
                styles.textLink,
                props.className ?? undefined,
            ])}
        >
            {props.children}
            <ConditionalIcons {...props} mappedConditionalIcons={icons} />
        </Clickable>
    );
});
